import { NavLink, Outlet } from 'react-router-dom'
import { Gift, ArrowsClockwise, CreditCard } from '@phosphor-icons/react'
import classNames from 'classnames'

export default function AdminLayout() {
  const linkClasses = (active: boolean) =>
    classNames(
      'flex items-center gap-2 px-2 py-3 text-sm leading-none rounded-3xl',
      active
        ? 'font-medium text-foreground'
        : 'text-foreground hover:bg-gray-800/5',
    )

  return (
    <div className="flex h-full border-t border-base-input">
      <aside className="w-[204px] bg-white border-r border-base-input flex flex-col justify-between shrink-0">
        <div className="flex flex-col gap-3 p-2">
          <NavLink
            to="/admin/customers"
            className={({ isActive }) => linkClasses(isActive)}
          >
            <Gift weight="regular" className="w-4 h-4 shrink-0" />
            Gift Portals
          </NavLink>
          <NavLink
            to="/admin/sync"
            className={({ isActive }) => linkClasses(isActive)}
          >
            <ArrowsClockwise weight="regular" className="w-4 h-4 shrink-0" />
            OC Sync
          </NavLink>
          <NavLink
            to="/admin/cancel-classic"
            className={({ isActive }) => linkClasses(isActive)}
          >
            <CreditCard weight="regular" className="w-4 h-4 shrink-0" />
            Cancel Cards
          </NavLink>
        </div>
      </aside>
      <div className="flex-1 min-w-0 min-h-0 overflow-auto bg-white">
        <Outlet />
      </div>
    </div>
  )
}
